import { styled } from '@core-ui/react-stitch';

const ClearButtonWrapper = styled.div(({ theme }) => ({
  button: {
    fontWeight: 'bold',
    fontSize: '0.9rem',
    color: theme.color.b1,
  },
}));

export default ClearButtonWrapper;
